import React from 'react';
import { observer } from 'mobx-react';
import { RatingTypeStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class RatingTypeCreate extends React.Component {

  onCreate = name => {
    RatingTypeStore.create({data: {name}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default RatingTypeCreate;
